import { useRef } from 'react';

const usePrevious = (value, isEqualFunc, saveInitial) => {
  const ref = useRef({
    value: value,
    prev: saveInitial ? value : null,
  });

  const current = ref.current.value;

  if (isEqualFunc ? !isEqualFunc(value, current) : value !== current) {
    ref.current = {
      value: value,
      prev: current,
    };
  }

  return ref.current.prev;
};

export default usePrevious;
